<textarea
	class="input-textarea {{ styleClass }}"
	[maxlength]="maxLength"
	[id]="inputId"
	type="text"
	[formControl]="control"
	enterkeyhint="done"
	[placeholder]="inputPlaceholder"
></textarea>
